import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../components/vendorWebFolder/helperFunctions/axiosInstance";

// to fetch vendor profile details
export const vendorProfileData = createAsyncThunk(
  "vendorProfile/profiledata",
  async (vendorId, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`/api/vendors/${vendorId}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const updateVendorProfileData = createAsyncThunk(
  "vendorProfile/editProfileData",
  async ({ vendorId, formData }, thunkAPI) => {
    try {
      const response = await axiosInstance.put(
        `/api/vendors/${vendorId}`,
        formData
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const vendorProfileSlice = createSlice({
  name: "vendorProfile",
  initialState: {
    vendorProfileDetails: {},
    error: null,
    loading: false,
  },
  reducers: {
    // const editProfileData(state, action){
    // }
  },

  extraReducers: (builder) => {
    builder
      .addCase(vendorProfileData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(vendorProfileData.fulfilled, (state, action) => {
        state.loading = false;
        state.vendorProfileDetails = action.payload;
      })
      .addCase(vendorProfileData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export default vendorProfileSlice.reducer;
